import { create } from "zustand"
import { useTicketsStore } from "./ticketsStore"
import { useKanbanTicketsStore } from "./kanbanTicketsStore"

/** Propaga o contato editado para os tickets em memória (lista de conversas + Kanban). */
const propagarContatoParaTickets = (contact) => {
  if (!contact?.id) return
  useTicketsStore.getState().atualizarContatoNosTickets(contact)
  useKanbanTicketsStore.getState().atualizarContatoNosTickets(contact)
}

/** Normaliza nome/imagem nos dois formatos de payload (listagem: nome/imagemPerfil; ticket: name/profilePicUrl). */
const contatoNomeImagemNormalizar = (contact, existente = {}) => {
  const oMesclado = { ...existente, ...contact }
  oMesclado.nome = contact.nome ?? contact.name ?? existente.nome ?? existente.name
  oMesclado.name = contact.name ?? contact.nome ?? existente.name ?? existente.nome
  oMesclado.imagemPerfil =
    contact.imagemPerfil ?? contact.profilePicUrl ?? existente.imagemPerfil ?? existente.profilePicUrl
  oMesclado.profilePicUrl =
    contact.profilePicUrl ?? contact.imagemPerfil ?? existente.profilePicUrl ?? existente.imagemPerfil
  return oMesclado
}

const useContactsStore = create((set) => ({
  contacts: [],
  searchParam: "",

  setContacts: (contacts) => set({ contacts }),
  setSearchParam: (query) => set({ searchParam: query }),
  resetContacts: () => set({ contacts: [] }),

  loadContacts: (newContacts) =>
    set((state) => {
      const updated = [...state.contacts]
      newContacts.forEach((contact) => {
        const idx = updated.findIndex((c) => c.id === contact.id)
        if (idx !== -1) updated[idx] = contatoNomeImagemNormalizar(contact, updated[idx])
        else updated.push(contatoNomeImagemNormalizar(contact))
      })
      return { contacts: updated }
    }),
  updateContact: (contact) => {
    set((state) => {
      const updated = [...state.contacts]
      const idx = updated.findIndex((c) => c.id === contact.id)
      if (idx !== -1) {
        // Backends retornam o contato em formatos distintos (listagem: nome/imagemPerfil;
        // update: name/profilePicUrl). Normaliza ambos e preserva a imagem quando o
        // retorno nao a trouxer, evitando que o avatar volte ao padrao apos editar.
        updated[idx] = contatoNomeImagemNormalizar(contact, updated[idx])
      } else {
        updated.unshift(contatoNomeImagemNormalizar(contact))
      }
      return { contacts: updated }
    })
    // Reflete a alteração nos cards do Kanban e na lista de conversas em tempo real.
    propagarContatoParaTickets(contact)
  },
  deleteContact: (contactId) =>
    set((state) => {
      const updated = state.contacts.filter((c) => c.id !== contactId)
      return { contacts: updated }
    }),
}))

export default useContactsStore
